import { render } from "./VerifyAppointment.vue?vue&type=template&id=1f406cda"
import script from "./VerifyAppointment.vue?vue&type=script&lang=js"
export * from "./VerifyAppointment.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__